<template>
  <tr class="captive-form-list-item">

    <td>
      <i v-if="item.isDefault"
         class="mdi mdi-star-circle"></i>
    </td>

    <td>
      {{ formattedLoginTypeName }}
    </td>

    <td>
      {{ formattedLoginTypeKey }}
    </td>

    <td>
      {{ item.fieldCount }}
    </td>

    <td>
      -
    </td>

    <td>
      {{ creationDate }}
    </td>

    <td>
      <captive-forms-list-item-actions :item="item"
                                       @deleted="emitReload"
                                       @edited="emitReload" />
    </td>

  </tr>
</template>

<script>
import CaptiveFormsListItemActions from "./actions/CaptiveFormsListItemActions.vue";

export default {
  components: {
    CaptiveFormsListItemActions,
  },

  data() {
    return {
      isActive: false,
      showEditForm: false,
      showingDeleteConfirmModal: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: false,
    },
    manage: {
      type: Boolean,
      default: false,
    },
    computed: {},
  },
  computed: {
    creationDate() {
      return this.$date.format(this.item.creationDate);
    },
    formattedLoginTypeKey() {
      let loginTypeKey;
      switch (this.item.type) {
        case "MAC":
          loginTypeKey = this.$t("message.loginPersonalize.message.noForm");
          break;
        case "CPF":
          loginTypeKey = "CPF";
          break;
        case "CELLPHONE":
          loginTypeKey = this.$t('message.loginPersonalize.message.telephone');
          break;
        case "EMAIL":
          loginTypeKey = "E-mail";
          break;
        case "EXTERNAL_SERVICE":
          loginTypeKey = this.$t(
            "message.loginPersonalize.message.externalService"
          );
          break;
        case "ACTIVE_DIRECTORY":
         loginTypeKey = this.$t(
            "Active Directory"
         );
          break;
        case "VOUCHER":
          loginTypeKey = "Voucher";
          break;
        default:
          break;
      }
      return loginTypeKey;
    },
    formattedLoginTypeName() {
      let loginTypeName;

      switch (this.item.type) {
        case "FACEBOOK":
          loginTypeName = "Facebook";
          break;
        case "TWITTER":
          loginTypeName = "Twitter";
          break;
        case "LINKEDIN":
          loginTypeName = "Linkedin";
          break;
        default:
          loginTypeName = this.item.name;
          break;
      }
      return loginTypeName;
    },
  },
  methods: {
    onEdited() {
      this.hideEditModal();
      this.emitEdited();
    },
    hideEditModal() {
      this.showEditForm = false;
    },
    emitReload() {
      this.$emit("reload");
    },
    emitEdited() {
      this.$emit("edited");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
